<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/7.png" />
      <div class="marginLeft15">所代理的生产商资料</div>
    </div>
    <!--企业信息列表的切换条-->
    <ListTab act="1" class="marginTop20"></ListTab>
    <!--不是缺省状态的列表-->
    <div v-if="li.length !== 0" class="marginTop20 pronList">
      <div class="upBtn addBtn" @click="changeInfo()">
        <i class="el-icon-plus"></i>添加生产厂商
      </div>
      <div class="infoList">
        <Accordion
          v-for="(infoForm, ind) in li"
          :show="true"
          :key="ind"
          :title="`${infoForm.company_name}-资料详情`"
          class="aAccordion"
        >
          <div class="componyInfoMainController">
            <!--审核状态-->
            <div class="shenhezhaungtai">
              <div class="zhaungtaiTitle">审核状态</div>
              <div class="zhaungtaiInfo tel">
                {{ infoForm.step_text }}
              </div>
            </div>
            <!--审核状态-->
            <div
              v-if="infoForm.profile_step === 3"
              class="shenhezhaungtai marginTop20"
            >
              <div class="zhaungtaiTitle">反馈意见</div>
              <div class="zhaungtaiInfo tel">
                {{ infoForm.checkmark }}
              </div>
            </div>
            <div v-if="parseInt(infoForm.hascode) === 1">
              <!-- 证书查看和下载 -->
              <div class="bookControll">
                <div class="bookName">
                  《云南省建设工程材料及设备信息登记卡》
                </div>
                <div class="bookup" @click="lockCertificate(infoForm.uuid)">
                  查看证书
                </div>
                <div class="bookup" @click="downCertificate(infoForm.uuid)">
                  下载证书
                </div>
                <div class="bookup" @click="printCertificate(infoForm.uuid)">
                  打印证书
                </div>
              </div>
              <div class="lines"></div>
            </div>
            <!--第一个区域-->
            <div class="componyInfoController marginTop20">
              <div class="aCompony">
                <div class="titles">企业名称</div>
                <div class="des marginTop20">{{ infoForm.company_name }}</div>
              </div>
              <div class="aCompony">
                <div class="titles">企业类型</div>
                <div class="des marginTop20">
                  {{ infoForm.showComponytype }}
                </div>
              </div>
              <div class="aCompony">
                <div class="titles">统一社会信用代码</div>
                <div class="des marginTop20">{{ infoForm.social_code }}</div>
              </div>
              <div class="aCompony">
                <div class="titles">注册资金（万元）</div>
                <div class="des marginTop20">
                  {{ infoForm.reg_capital }}
                  {{ infoForm.reg_unit }}
                </div>
              </div>
              <div class="aCompony">
                <div class="titles">法定代表人</div>
                <div class="des marginTop20">{{ infoForm.legal_name }}</div>
              </div>
              <div class="aCompony">
                <div class="titles">法定代表人联系电话</div>
                <div class="des marginTop20">{{ infoForm.legal_tel }}</div>
              </div>
              <div class="aCompony">
                <div class="titles">企业注册地址</div>
                <div class="des marginTop20">
                  <div class="flexAre">
                    <Areselect
                      :onlyshow="true"
                      v-model="infoForm.areCodeList"
                    ></Areselect>
                    {{ infoForm.register_address }}
                  </div>
                </div>
              </div>
              <div v-if="infoForm.yinyezhizhao[0]" class="aCompony">
                <div class="titles">营业执照（彩色扫描件）</div>
                <div class="des marginTop20">
                  <a
                    :href="infoForm.yinyezhizhao[0].viewurl"
                    target="_blank"
                    style="color:#00B1FF;"
                  >
                    营业执照（彩色扫描件）.JPG
                  </a>
                </div>
              </div>
            </div>
            <div class="lines"></div>
            <!--第二个区域-->
            <div class="componyInfoController">
              <div class="aCompony">
                <div class="titles">经办人</div>
                <div class="des marginTop20">{{ infoForm.contact_person }}</div>
              </div>
              <div class="aCompony">
                <div class="titles">经办人电话</div>
                <div class="des marginTop20">{{ infoForm.contact_tel }}</div>
              </div>
              <div class="aCompony">
                <div class="titles">微信号</div>
                <div class="des marginTop20">{{ infoForm.wx_number }}</div>
              </div>
              <div class="aCompony">
                <div class="titles">通信地址</div>
                <div class="des marginTop20">
                  {{ infoForm.contact_address }}
                </div>
              </div>
            </div>
            <!-- 第三个区域 企业资料库 -->
            <div class="total marginTop40">
              <div class="item">
                <div class="titleOverAll">
                  建厂环评批复文件
                </div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.factory_comment"
                  class="width320"
                ></UpFile>
              </div>
              <div class="item marginLeft40">
                <div class="titleOverAll">质量管理体系认证证书</div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.quality_control"
                  class="width320"
                ></UpFile>
              </div>
              <div class="item marginLeft40">
                <div class="titleOverAll">环境管理体系认证证书</div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.environment_cert"
                  class="width320"
                ></UpFile>
              </div>
            </div>
            <div class="total marginTop40">
              <div class="item">
                <div class="titleOverAll">能源管理体系认证证书</div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.energy_cert"
                  class="width320"
                ></UpFile>
              </div>
              <div class="item marginLeft40">
                <div class="titleOverAll">职业健康安全管理体系认证证书</div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.profession_cert"
                  class="width320"
                ></UpFile>
              </div>
              <div class="item marginLeft40">
                <div class="titleOverAll">工作场所有害因素第三方检测报告</div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.workplace_cert"
                  class="width320"
                ></UpFile>
              </div>
            </div>
            <div class="total marginTop40">
              <div class="item">
                <div class="titleOverAll">商标注册证</div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.trademark_cert"
                  class="width320"
                ></UpFile>
              </div>
              <div class="item marginLeft40">
                <div class="titleOverAll">排污许可证</div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.sewage_cert"
                  class="width320"
                ></UpFile>
              </div>
              <div class="item marginLeft40">
                <div class="titleOverAll">其它资质荣誉证书</div>
                <UpFile
                  :onlyshow="onlyshow"
                  v-model="infoForm.other_cert"
                  class="width320"
                ></UpFile>
              </div>
            </div>
            <!--按钮-->
            <div
              class="btnController marginTop20"
              v-if="infoForm.profile_step !== 4"
            >
              <el-popconfirm
                @onConfirm="del(infoForm.id)"
                title="您确定要删除吗？"
              >
                <div slot="reference" class="yuanLouKongBtn delBtn">
                  删除资料
                </div>
              </el-popconfirm>
              <div
                @click="changeInfo(infoForm.id)"
                class="yuanLouKongBtn marginLeft15"
              >
                修改资料
              </div>
            </div>
          </div>
        </Accordion>
      </div>
    </div>
    <!--缺省添加-->
    <Plan v-else class="queShengAdd marginTop20">
      <div class="nullImgHeight">
        <div class="nullImgController">
          <img src="@/assets/img/null.jpg" />
          <div>您还暂未添加所代理的生产商资料！</div>
        </div>
        <div @click="changeInfo()" class="yuanBtn marginTop20">
          添加所代理的生产商资料
        </div>
      </div>
    </Plan>
  </div>
</template>
<script>
import Areselect from "@/components/Areselect.vue";
import Plan from "@/components/Plan.vue";
import ListTab from "@/components/ListTab.vue";
import Accordion from "@/components/Accordion.vue";
import Api from "@/plugins/axios.js";
import UpFile from "@/components/UpFile.vue";
export default {
  components: {
    Areselect,
    Accordion,
    ListTab,
    Plan,
    UpFile
  },
  data() {
    return {
      onlyshow: true,
      fenlei: [], // 分类
      li: []
    };
  },
  async mounted() {
    // 企业信息获得，用于操作顶部的导航条显示状态
    const re = await Api.userinfo(this.$store.state.token);
    this.$store.commit("SET_USERINFO", re);
    this.$store.commit("SET_USERID", re.id);

    await this.getFlList();
    await this.getList();
  },
  methods: {
    // 下面是证书的三个方法
    lockCertificate(uuid) {
      this.$router.push({
        name: "Card",
        query: {
          uuid,
          agentType: 2,
          type: "look"
        }
      });
    },
    downCertificate(uuid) {
      this.$router.push({
        name: "Card",
        query: {
          uuid,
          agentType: 2,
          type: "down"
        }
      });
    },
    printCertificate(uuid) {
      this.$router.push({
        name: "Card",
        query: {
          uuid,
          agentType: 2,
          type: "print"
        }
      });
    },
    // 删除
    async del(id) {
      try {
        await Api.agentDelete(this.$store.state.token, id);
        this.getList();
      } catch (error) {
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
    },
    // 获得企业分类
    async getFlList() {
      const li = await Api.getQyFl("business_class", 1);
      this.fenlei = li;
    },
    // 跳转到新增列表
    changeInfo(id) {
      if (!id) {
        id = null;
      }
      this.$router.push({
        query: {
          uuid: id,
          type: "production"
        },
        name: "AgentInfo"
      });
    },
    // 获得列表
    async getList() {
      const that = this;
      const re = await Api.agentLi(this.$store.state.token);
      this.li = re.data.map(function(e) {
        // 显示企业类型
        e.showComponytype = null;
        for (let index = 0; index < that.fenlei.length; index++) {
          const element = that.fenlei[index];
          // console.log(parseInt(info.company_cate), parseInt(element.id));
          if (parseInt(e.company_cate) === parseInt(element.id)) {
            console.log(element);
            e.showComponytype = element.name;
          }
        }
        // 地址下拉
        let arr = [];
        if (e.province_code) {
          arr[0] = e.province_code;
        }
        if (e.city_code) {
          arr[1] = e.city_code;
        }
        if (e.area_code) {
          arr[2] = e.area_code;
        }
        e.areCodeList = arr;
        // 营业执照显示
        e.yinyezhizhao = [];
        if (e.business_license) {
          e.yinyezhizhao = [
            {
              name: "",
              url: e.business_license,
              viewurl: Api.domain + e.business_license
            }
          ];
        }
        return e;
      });
    }
  }
};
</script>
<style lang="less" scoped>
// 缺省添加页
.queShengAdd {
  text-align: center;
  .nullImgController {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    img {
      width: 100px;
      margin-right: 20px;
    }
  }
  .nullImgHeight {
    padding: 50px 0px;
  }
}
// 供应商列表
.pronList {
  .addBtn {
    width: 100px;
  }
  .infoList {
    .aAccordion {
      margin-top: 20px;
    }
  }
}
//证书查看下载
.bookControll {
  display: flex;
  align-items: center;
  padding-top: 25px;
  .bookName {
    font-weight: 600;
    color: #213743;
    font-size: 20px;
    display: flex;
    align-items: center;
  }
  .bookup {
    color: rgb(0, 177, 255);
    margin-left: 30px;
    font-size: 14px;
    font-weight: 400;
    height: 20px;
    cursor: pointer;
    border-bottom: rgb(0, 177, 255) 2px solid;
  }
}
// 企业信息显示详情
.componyInfoMainController {
  // 审核详情
  .shenheInfoController {
    .shenheTitle {
      padding: 16px 32px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
    // 详情容器
    .shenheInfo {
      border-top: 1px solid rgba(230, 230, 230, 1);
      padding: 24px 32px;
      display: flex;
      .shenheCon {
        margin-left: 20px;
        .shenheTi {
          font-size: 12px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
        }
        .shenheDes {
          margin-top: 5px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          opacity: 1;
        }
      }
    }
  }
  // 审核状态
  .shenhezhaungtai {
    padding: 12px 32px;
    display: flex;
    // 状态标题
    .zhaungtaiTitle {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      opacity: 1;
    }
    // 状态详情
    .zhaungtaiInfo {
      margin-left: 30px;
      font-size: 14px;
      font-weight: 400;
      opacity: 1;
    }
  }
  // 蓝色
  .tel {
    color: #00b1ff;
  }
  .shenheInfoController,
  .shenhezhaungtai {
    background-color: #f0f5f7;
    border-radius: 10px;
  }
  // 企业信息显示详情
  .componyInfoController {
    display: flex;
    flex-wrap: wrap;
    .aCompony {
      width: 33%;
      min-width: 33%;
      margin-top: 35px;
      // 标题
      .titles {
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
      }
      // 描述
      .des {
        font-size: 12px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        a {
          text-decoration: none;
          color: #00b1ff;
        }
      }
    }
    .aCompony:nth-child(1),
    .aCompony:nth-child(2),
    .aCompony:nth-child(3) {
      margin-top: 0px;
    }
  }
  .btnController {
    text-align: center;
  }
}
.flexAre {
  display: flex;
  align-items: center;
}
</style>
